<template>
  <div
    v-if="signingUrl"
    class="ui button primary"
    v-tooltip="toolTipText"
    @click="showUploader(!uploaderOpen)"
  >
    <template v-if="!uploaderOpen">
      <i class="ui icon suus-computer-upload"></i>
      <span class="mobile hidden">{{ t$Upload(".text") }}</span>
    </template>
    <template v-else>
      <i class="ui icon suus-simple-remove"></i>
      <span class="mobile hidden">{{ t$Cancel(".text") }}</span>
    </template>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue"
import useTranslate from "features/common/translate/concerns/useTranslate"

export default defineComponent({
  name: "UploadButton",
  props: {
    signingUrl: {
      type: String,
      default: null,
    },
    uploaderOpen: {
      type: Boolean,
      default: false,
    },
    showUploader: {
      type: Function as PropType<(show: boolean) => void>,
    },
  },
  setup(props) {
    const { t$: t$Upload } = useTranslate("drive.uploadButton")
    const { t$: t$Cancel } = useTranslate("drive.cancelUploadButton")

    const toolTipText = computed(() => {
      return props.uploaderOpen ? t$Cancel(".tooltip") : t$Upload(".tooltip")
    })

    return {
      toolTipText,
      t$Upload,
      t$Cancel,
    }
  },
})
</script>
